import React from 'react';
import SEO from '@bradgarropy/gatsby-plugin-seo';

import Layout from '../components/layout';

const Index = () => {
  return (
    <Layout>
      <SEO
        title='Praiser | Boost your team morale'
        description='Boost your team moral by praising them'
      />
      <div className='sm:text-center lg:text-left sm:max-w-xl '>
        <h2 className='text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-6xl lg:text-7xl'>
          {`Praise your `}
          <br className='xl:hidden' />
          <span className='text-indigo-600'>team members</span>
        </h2>
        <p className='mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:mx-auto md:mt-5 md:text-xl lg:mx-0'>
          Say thanks and show your team members that you appreciate them and
          their work. A team that feels appreciated is more happy and
          productive. Recognising their work also motivates them to work harder.
        </p>
        <div className='mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start'>
          <a href='/install'>
            <img
              className='h-12'
              alt='Add to Slack'
              src='https://platform.slack-edge.com/img/add_to_slack.png'
              srcSet='https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x'
            />
          </a>
        </div>
      </div>
    </Layout>
  );
};

export default Index;
